<template>
  <page-generate v-if="currentService === 'create_background_for_image'"/>
  <page-inpaint v-if="currentService === 'inpaint'"/>
  <page-outpaint v-if="currentService === 'outpaint'"/>
  <page-upscale v-if="currentService === 'upscale'"/>
  <!-- <page-infographics v-if="currentService === 'infographics'"/> -->
  <page-remove-background v-if="currentService === 'remove_background'"/>
  <page-shadow v-if="currentService === 'shadow'"/>
  <page-watermarks v-if="currentService === 'watermarks'"/>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common/index';

import PageGenerate from '@/components/pages/Generate/Generate.vue';
import PageInpaint from '@/components/pages/Inpaint/Inpaint.vue';
import PageOutpaint from '@/components/pages/Outpaint/Outpaint.vue';
import PageUpscale from '@/components/pages/Upscale/Upscale.vue';
// import PageInfographics from '@/components/pages/Infographics/Infographics.vue';
import PageRemoveBackground from '@/components/pages/RemoveBackground/RemoveBackground.vue';
import PageShadow from '@/components/pages/Shadow/Shadow.vue';
import PageWatermarks from '@/components/pages/Watermarks/Watermarks.vue';

const { currentService } = storeToRefs(useCommonStore());
</script>
